<template>
	<div>
		<div class="content">
			<div class="card-list" v-show="singleProjectPageShow">
				<div v-for="(items,index) in singleProjects" :key="index" style="display:flex;width:100%;" :style="{'margin-top':index==0?'0px':'32px'}">
					<pms-project-card v-for="(item,sindex) in items" :key="item.id" :style="{'margin-left':sindex==0?'0px':'66px'}" :item="item"
					 @refreshprojects="refreshprojects" @projectDetail="projectDetail"></pms-project-card>
				</div>
				<div class="pagination">
					<el-pagination style="float:right" small background @current-change="singleProjectPageChange" layout="prev, pager, next"
					 :total="singleTotalProjects" :page-size="perPage" v-show="singleTotalProjects>1"></el-pagination>
				</div>
			</div>
		</div>
	</div>
</template>

<style lang="scss" scoped>
	.content {
		margin-top: 15px;
		width: 1200px;
		height: 100%;
		margin-left: auto;
		margin-right: auto;
		background-color: #ffffff;
		border-bottom: 15px #f0f2f5 solid;
	}

	.topdiv {
		display: flex;

		.topdiv-title {
			font-size: 18px;
			margin-top: 32px;
			margin-left: 32px;
		}

		.create-project-button {
			background-color: #1890ff;
			margin-top: 32px;
			margin-left: auto;
			margin-right: 32px;
			height: 32px;
			width: 85px;
			border-radius: 2px;
			font-size: 14px;
		}
	}

	.line {
		height: 1px;
		margin-top: 12px;
		margin-left: 32px;
		margin-right: 32px;
		padding: 0px;
		background-color: #e8e8e8;
	}

	.sction {
		height: 33px;
		margin-left: 32px;
		margin-right: 32px;
		// background-color: #e8e8e8;
		display: flex;
		margin-top: 18px;
		align-items: center;

		.sction-vline {
			background-color: #716f6f;
			width: 4px;
			height: 20px;
		}

		.sction-title {
			font-size: 18px;
			margin-left: 11px;
		}

		.sction-expend {
			font-size: 16px;
			margin-left: 29px;
			color: #4a90e2;
		}
	}

	.card-list {
		// background-color: #716f6f;
		margin-top: 17px;
		height: auto;
		margin-left: 32px;
		margin-right: 32px;
		padding: 86px 0;

		.pagination {
			background-color: #ffffff;
			width: 100%;
			margin-top: 73px;
			height: 40px;
		}
	}

	.el-dialog__footer {
		text-align: center;
	}

</style>

<script>
	import PMSProjectCard from "./PMSProjectCard";
	import config from "@/js/utils/config";
	import CONSTANTS from "@/js/utils/constants";
	import {
		Loading
	} from "element-ui";
	export default {
		name: "PMSWorkerbench",
		components: {
			"pms-project-card": PMSProjectCard
		},
		data() {
			return {
				singleProjectPage: 1,
				mergeProjectPage: 1,
				perPage: 15,
				singleProjectPageShow: true,
				mergeProjectPageShow: true,
				singleProjects: [],
				mergeProjects: [],
				singleTotalProjects: 0,
				mergeTotalProjects: 0
			};
		},

		activated() {
			this.refreshprojects();
		},
		beforeRouteUpdate (to, from, next) {
			console.log('to.....', to);
		},
		methods: {

			loadProjects() {
				this.refreshprojects();
			},

			refreshprojects() {
				//加载网络请求数据
				this.getSingleProject();
			},

			projectDetail(projectId, edit, jobUid) {
				let routeData = this.$router.resolve({
					path: "/project-detail",
					query: {
						id: projectId,
						uid: jobUid,
						edit: edit
					}
				});
				window.open(routeData.href, "_blank");
			},

			getSingleProject() {
				let loadingInstance = Loading.service({
					lock: true,
					text: "努力处理数据中，请稍候",
					spinner: "el-icon-loading",
					background: "rgba(0, 0, 0, 0.7)"
				});
				var that = this;
				let url = config.api.history_jobs;
				let params = {
					operation: 0,
					page: this.singleProjectPage,
					per_page: this.perPage,
					sorts: "create_time|desc",
					ride: 0,
					over: 0
				};
				this.HttpUtils.get(url, params)
					.then(result => {
						loadingInstance.close();

						that.singleProjects = that.groupProjects(result.data.items);
						that.singleTotalProjects = result.data.pagination.total;
					})
					.catch(execption => {
						loadingInstance.close();
						console.log(execption);
					});
			},

			groupProjects(items) {
				var num = 3; //每个子数组里的元素个数
				var projects = new Array(Math.ceil(items.length / num));
				for (var i = 0; i < projects.length; i++) {
					projects[i] = new Array();
					for (var j = 0; j < num; j++) {
						if (i * num + j < items.length) {
							projects[i][j] = items[i * num + j];
						}
					}
				}
				return projects;
			},

			singleProjectPageChange(val) {
				this.singleProjectPage = val;
				this.getSingleProject();
			}
		}
	};

</script>



// WEBPACK FOOTER //
// src/js/modules/project/ui/etl_project/project_history_list/PMSWorkerbench.vue